// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-6295542b],td[data-v-6295542b],th[data-v-6295542b]{border:1px solid #c2c2c2;padding:8px 12px}table[data-v-6295542b]{width:100%;border-collapse:collapse}.header-column[data-v-6295542b]{background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
